<script>
export default {
  name: "AboutUs",
  setup() {
    return {};
  },
};
</script>

<template>
  <div>

  </div>
</template>

<style scoped>

</style>